

























import Vue from 'vue'
import { mapMutations } from 'vuex'
import { $, getIOSVersion, uaIsIOS, sleep, versionCompare } from '@/utils/helpers'
import { canvasToBlob, loadImage } from '@/utils/ImageUtil'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default Vue.extend({
  name: 'ProfileEditImage',
  data() {
    return {
      type: '',
      ratio: 0,
      imgWidth: 0,
      imgHeight: 0,
      top: 0,
      left: 0,
      tmpTop: 0,
      tmpLeft: 0,
      width: 100,
      height: 100,
      relativeX: 0,
      relativeY: 0,
      startX: 0,
      startY: 0,
      isLoading: false,
      imgEditor: null
    }
  },
  computed: {
    style(): any {
      return {
        'background-image': `url(${this.$route.params.imageData})`,
        'background-position': 'center',
        'background-size': 'cover',
        'will-change': 'height,left,top,width,transform',
        position: 'absolute',
        top: `${this.top}%`,
        left: `${this.left}%`,
        height: `${this.height}%`,
        width: `${this.width}%`,
        transition: 'all .2s ease',
        'transform-origin': `${this.left}% ${this.top}% 0px`
      }
    },

    /**
     * 生成される画像のクオリティ
     */
    QUALITY(): number {
      return 0.5
    },

    /**
     * キャンバスのサイズ
     */
    CANVAS_SIZE(): number {
      return 1080
    }
  },
  async created(this: any) {
    if (!this.$route.params.imageData) {
      this.$router.replace('/profile/edit')
      return
    }

    const cors = uaIsIOS && versionCompare(getIOSVersion(), '10.2')
    const img = await loadImage({ src: this.$route.params.imageData, cors: cors })
    this.imgWidth = img.width
    this.imgHeight = img.height

    // 縦長判定にもとづいてアスペクト比を計算して画面内に短い方が収まるようにする
    // 大きい方=大きい方/小さい方(小数点第3位で四捨五入), 小さい方=100%
    // 座標は(1 - アスペクト比)/2) で中央を求めてから小数点第4位で四捨五入
    if (img.naturalWidth > img.naturalHeight) {
      this.ratio = img.naturalWidth / img.naturalHeight
      const x = Math.round(((1 - this.ratio) / 2) * 1000000) / 10000
      this.type = 'horizontal'
      this.width = Math.round(this.ratio * 100000) / 1000
      this.left = x
      this.tmpLeft = this.left
      this.tmpTop = 0
    } else if (img.naturalHeight > img.naturalWidth) {
      this.ratio = img.naturalHeight / img.naturalWidth
      const y = Math.round(((1 - this.ratio) / 2) * 1000000) / 10000
      this.ratio = img.naturalHeight / img.naturalWidth
      this.type = 'vertical'
      this.height = Math.round(this.ratio * 100000) / 1000
      this.top = y
      this.tmpTop = this.top
      this.tmpLeft = 0
    } else {
      this.type = 'square'
    }
  },
  async mounted() {
    let img = await loadImage({ src: this.$route.params.imageData })
    if (img.width !== img.height) {
      this.imgEditor = $('.ProfileEditImage__image-editor')
      if (this.imgEditor) {
        this.imgEditor.addEventListener('mousedown', this.handleTouchStart, { passive: true })
        this.imgEditor.addEventListener('touchstart', this.handleTouchStart, { passive: true })
      }

      disableBodyScroll($('html'))
    }
  },
  beforeDestroy() {
    // 以下の処理は destoryed() だとエラーになる？
    if (this.imgEditor) {
      this.imgEditor.removeEventListener('mousedown', this.handleTouchStart, false)
      this.imgEditor.removeEventListener('touchstart', this.handleTouchStart, false)
      enableBodyScroll($('html'))
      this.imgEditor = null
    }
    if (this.$route.params.imageData) {
      URL.revokeObjectURL(this.$route.params.imageData)
      this.$route.params.imageData = null
    }
  },
  methods: {
    ...mapMutations('MyData', ['setMyProfileImageURL']),

    /**
     * 画像の比率？を取得する
     */
    getRatio(width: number, height: number): number {
      let value
      if (width > height) {
        value = width / height
      } else {
        value = height / width
      }
      return Math.round(value * 100000) / 1000
    },

    /**
     * 画像の移動開始地点の取得と移動するためのイベントの設定
     */
    handleTouchStart(event) {
      event = this.getTouchEvent(event)

      // 要素内の相対座標を取得
      this.relativeX = event.pageX - event.target.offsetLeft
      this.relativeY = event.pageY - event.target.offsetTop

      // ムーブイベントにコールバック
      document.body.addEventListener('mousemove', this.moveImage, false)
      document.body.addEventListener('touchmove', this.moveImage, false)
    },

    /**
     * 画像の移動
     */
    moveImage(event) {
      // フリックした時に動かないようにデフォルト動作を抑制
      event.preventDefault()

      event = this.getTouchEvent(event)

      // マウスが動いた場所に要素を動かす
      // const xratio = this.tmpLeft === 0 ? 1 : this.tmpLeft/100
      // const yratio = this.tmpTop === 0 ? 1 : this.tmpTop/100
      // this.left = (event.pageX - this.relativeX)*xratio
      // this.top = (event.pageY - this.relativeY)*yratio
      // if (this.type === 'horizontal') {
      //   this.left *= -(1 - (this.ratio/10))
      // } else if (this.type === 'vertical') {
      //   this.top *= -(1 - (this.ratio/10))
      // }
      const xratio = this.tmpLeft === 0 ? 1 : this.tmpLeft / 100
      const yratio = this.tmpTop === 0 ? 1 : this.tmpTop / 100
      this.left = event.pageX - this.relativeX
      this.top = event.pageY - this.relativeY
      if (this.type === 'horizontal') {
        this.left *= (1 - this.ratio / 10) * -xratio
        this.top *= -xratio
      } else if (this.type === 'vertical') {
        this.left *= -yratio
        this.top *= (1 - this.ratio / 10) * -yratio
      }

      // マウスボタンが離されたとき、またはカーソルが外れたときに発火
      document.body.addEventListener('mouseleave', this.handleTouchEnd, false)
      document.body.addEventListener('touchleave', this.handleTouchEnd, false)
      if (this.imgEditor) {
        this.imgEditor.addEventListener('mouseup', this.handleTouchEnd, false)
        this.imgEditor.addEventListener('touchend', this.handleTouchEnd, false)
      }
    },

    /**
     * 画像の移動終了
     */
    handleTouchEnd(event) {
      event = this.getTouchEvent(event)

      // 位置が最大値以下、0以上になるように調整
      const max = Math.round((1 - this.ratio) * 1000000) / 10000
      if (this.type === 'horizontal') {
        if (this.left > 0) {
          this.left = 0
        } else if (this.left <= max) {
          this.left = max
        }
        this.top = 0
      } else if (this.type === 'vertical') {
        if (this.top > 0) {
          this.top = 0
        } else if (this.top <= max) {
          this.top = max
        }
        this.left = 0
      }

      // イベントハンドラの削除
      document.body.removeEventListener('mousemove', this.moveImage, false)
      document.body.removeEventListener('touchmove', this.moveImage, false)
      if (this.imgEditor) {
        this.imgEditor.removeEventListener('mouseup', this.handleTouchEnd, false)
        this.imgEditor.removeEventListener('touchend', this.handleTouchEnd, false)
      }
    },

    /**
     * タッチとマウスイベントの差異を吸収
     */
    getTouchEvent(event: TouchEvent): TouchEvent | Touch {
      if (event.type === 'touchstart' || event.type === 'touchmove' || event.type === 'touchend') {
        return event.changedTouches[0]
      }
      return event
    },

    /**
     * 画像をアップロードする
     */
    async uploadImage(this: any) {
      if (!this.$route.params.imageData && !sessionStorage.getItem('profileImageFile')) {
        return
      }
      this.isLoading = true

      // left と top の値の編集が完了していないおそれがあるので少しだけ sleep
      await sleep(500)

      const blob = await this.createImage(this.$route.params.imageData)
      const message = '投稿が完了しました。\n事務局が確認後、他のユーザへ公開されます。'

      try {
        const fd = new FormData()
        fd.append('page', 'save')
        fd.append('up_file', blob, 'image/jpeg')
        sessionStorage.removeItem('profileImageFile')
        const res = await this.$http.post('/profile_file_up/', fd)
        if (res.data.error) {
          throw new Error(res.data.error)
        }
        this.files = []
        this.setMyProfileImageURL(res.data.profile_image_url)
        this.$_alert(message)
        this.$router.back()
      } catch (err) {
        alert(err)
      } finally {
        URL.revokeObjectURL(this.$route.params.imageData)
        this.isLoading = false
      }
    },

    /**
     * 編集したデータをもとに画像を生成する
     */
    async createImage(imageData: string): Promise<Blob> {
      let canvas: HTMLCanvasElement = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let cros = uaIsIOS && versionCompare(getIOSVersion(), '10.2')
      let img = await loadImage({ src: imageData, cors: cros })
      // 小さい方のサイズを使う
      const size =
        window.screen.width < window.screen.height ? window.screen.width : window.screen.height
      canvas.width = this.CANVAS_SIZE
      canvas.height = this.CANVAS_SIZE
      canvas.setAttribute('style', `width: ${size}px; height: ${size}px;`)

      let scale = 1
      let x = 0
      let y = 0
      // 大きい方のサイズを計算し、そこに移動値を掛けることで実際に画像を動かした値をが算出できる
      // 小さい方の計算は scale を一旦かけてから戻さないとなぜか黒い箇所ができてしまう
      if (this.type === 'horizontal' || this.type === 'square') {
        scale = canvas.height / this.imgHeight
        x = size * this.ratio * (this.left / 100)
        y = (canvas.height - this.imgHeight * scale) / scale / 2
      } else if (this.type === 'vertical') {
        scale = canvas.width / this.imgWidth
        x = (canvas.width - this.imgWidth * scale) / scale / 2
        y = size * this.ratio * (this.top / 100)
      }
      ctx.save()
      ctx.translate(x, y)
      ctx.scale(scale, scale)
      ctx.drawImage(img, 0, 0)
      ctx.restore()

      const blob = await canvasToBlob(canvas, this.QUALITY)
      ctx = null
      canvas = null
      return blob
    }
  }
})
